import { useEffect } from 'react';

/**
 * Set the document title for the current page.
 * Automatically appends " | Smartworld Group" to keep brand consistent.
 */
const useDocumentTitle = (title) => {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} | Smartworld Group`;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default useDocumentTitle;
